import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'
import Home from '@/views/home/index'
// 在客户端判断是否使用SSR，路由页面不能使用异步引入
import Detail from '@/views/detail/index'
import About from '@/views/about/index'
import NotFound from '@/views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: {
          title: '风铃笔记',
          icon: 'el-icon-s-home',
          keepAlive: true,
          ssr: true
        }
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import('@/views/search/index.vue'),
        meta: {
          title: '文章列表',
          icon: 'el-icon-search',
          keepAlive: true,
          ssr: false
        }
      },
      // {
      //   path: '/detail',
      //   name: 'Detail',
      //   component: () => import('../views/detail/index'),
      //   meta: {
      //     title: '文章详情',
      //     icon: 'el-icon-document',
      //     keepAlive: false
      //   }
      // },
      {
        // 使用params传参
        path: '/article/detail/:articleId',
        name: 'ArticleDetail',
        component: Detail,
        meta: {
          title: '文章详情',
          icon: 'el-icon-document',
          keepAlive: false,
          ssr: true
        }
      },
      {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
          title: '关于',
          icon: 'el-icon-info',
          keepAlive: true,
          ssr: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登陆 | 风铃笔记',
      ssr: false
    },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      title: '欢迎注册 | 风铃笔记',
      ssr: false
    },
    component: () => import('@/views/register/index.vue')
  },
  // {
  //   path: '/home',
  //   name: 'HomePage',
  //   redirect: '/'
  // },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  // 捕获所有未匹配的路径并跳转到 404 页面
  {
    path: '*',
    name: 'OtherPage',
    redirect: '/404'
  }
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

//创建createRouter工厂函数v
export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: routes,
    // 设置页面滚动到指定位置  https://router.vuejs.org/zh/guide/advanced/scroll-behavior.html
    scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      // return { x: 0, y: 0 }
      if (to.path !== '/' && to.path !== '/search') {
        return { x: 0, y: 0 }
      }
      if (savedPosition) {
        return savedPosition;
      } else {
        return { top: 0 };
      }
    }
  })
}

// const router = createRouter()

// export function resetRouter () {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher
// }

// export default router
